/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivateProfileBody,
  ApiError,
  EmailUpdateBody,
  LoginCodeBody,
  RequestEmailUpdateBody,
  RequestEmailUpdateResponse,
  RequestLoginCodeBody,
  RequestLoginCodeResponse,
  RequestMagicLinkBody,
  RequestPasswordResetBody,
  RequestPasswordResetResponse,
  ResetPasswordBody,
  Token,
} from '../models/index';
import {
    ActivateProfileBodyFromJSON,
    ActivateProfileBodyToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    EmailUpdateBodyFromJSON,
    EmailUpdateBodyToJSON,
    LoginCodeBodyFromJSON,
    LoginCodeBodyToJSON,
    RequestEmailUpdateBodyFromJSON,
    RequestEmailUpdateBodyToJSON,
    RequestEmailUpdateResponseFromJSON,
    RequestEmailUpdateResponseToJSON,
    RequestLoginCodeBodyFromJSON,
    RequestLoginCodeBodyToJSON,
    RequestLoginCodeResponseFromJSON,
    RequestLoginCodeResponseToJSON,
    RequestMagicLinkBodyFromJSON,
    RequestMagicLinkBodyToJSON,
    RequestPasswordResetBodyFromJSON,
    RequestPasswordResetBodyToJSON,
    RequestPasswordResetResponseFromJSON,
    RequestPasswordResetResponseToJSON,
    ResetPasswordBodyFromJSON,
    ResetPasswordBodyToJSON,
    TokenFromJSON,
    TokenToJSON,
} from '../models/index';

export interface CreateEmailUpdateRequestRequest {
    requestEmailUpdateBody?: RequestEmailUpdateBody;
}

export interface CreateLoginCodeRequestRequest {
    requestLoginCodeBody?: RequestLoginCodeBody;
}

export interface CreatePassportActivateProfileIdRequest {
    id: string;
    activateProfileBody?: ActivateProfileBody;
}

export interface CreatePassportMagicSendRequest {
    requestMagicLinkBody?: RequestMagicLinkBody;
}

export interface CreatePasswordResetRequestRequest {
    requestPasswordResetBody?: RequestPasswordResetBody;
}

export interface GetPassportMagicCallbackRequest {
    token: string;
}

export interface GetPhoneNumberVerifyCodeRequest {
    code: string;
}

export interface UpdateEmailUpdateIdVerifyRequest {
    id: string;
    emailUpdateBody?: EmailUpdateBody;
}

export interface UpdateLoginCodeIdVerifyRequest {
    id: string;
    loginCodeBody?: LoginCodeBody;
}

export interface UpdatePasswordResetIdVerifyRequest {
    id: string;
    resetPasswordBody?: ResetPasswordBody;
}

/**
 * VerificationsApi - interface
 * 
 * @export
 * @interface VerificationsApiInterface
 */
export interface VerificationsApiInterface {
    /**
     * Used by users to request a email update verification code
     * @param {RequestEmailUpdateBody} [requestEmailUpdateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    createEmailUpdateRequestRaw(requestParameters: CreateEmailUpdateRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestEmailUpdateResponse>>;

    /**
     * Used by users to request a email update verification code
     */
    createEmailUpdateRequest(requestParameters: CreateEmailUpdateRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestEmailUpdateResponse>;

    /**
     * Used by users to request a login verification code
     * @param {RequestLoginCodeBody} [requestLoginCodeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    createLoginCodeRequestRaw(requestParameters: CreateLoginCodeRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestLoginCodeResponse>>;

    /**
     * Used by users to request a login verification code
     */
    createLoginCodeRequest(requestParameters: CreateLoginCodeRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestLoginCodeResponse>;

    /**
     * Used by new user to activate a temporary profile
     * @param {string} id 
     * @param {ActivateProfileBody} [activateProfileBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    createPassportActivateProfileIdRaw(requestParameters: CreatePassportActivateProfileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>>;

    /**
     * Used by new user to activate a temporary profile
     */
    createPassportActivateProfileId(requestParameters: CreatePassportActivateProfileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token>;

    /**
     * Used by users to request a login magic link
     * @param {RequestMagicLinkBody} [requestMagicLinkBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    createPassportMagicSendRaw(requestParameters: CreatePassportMagicSendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to request a login magic link
     */
    createPassportMagicSend(requestParameters: CreatePassportMagicSendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to request a password reset verification code
     * @param {RequestPasswordResetBody} [requestPasswordResetBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    createPasswordResetRequestRaw(requestParameters: CreatePasswordResetRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestPasswordResetResponse>>;

    /**
     * Used by users to request a password reset verification code
     */
    createPasswordResetRequest(requestParameters: CreatePasswordResetRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestPasswordResetResponse>;

    /**
     * Used to create a phone number verification text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    createPhoneNumberRequestRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to create a phone number verification text
     */
    createPhoneNumberRequest(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Magic link callback — validates token and redirects with auth token or to registration
     * @param {string} token Magic link JWT token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    getPassportMagicCallbackRaw(requestParameters: GetPassportMagicCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Magic link callback — validates token and redirects with auth token or to registration
     */
    getPassportMagicCallback(requestParameters: GetPassportMagicCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to verify a phone number.
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    getPhoneNumberVerifyCodeRaw(requestParameters: GetPhoneNumberVerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to verify a phone number.
     */
    getPhoneNumberVerifyCode(requestParameters: GetPhoneNumberVerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to reset their password after they get a verification code.
     * @param {string} id 
     * @param {EmailUpdateBody} [emailUpdateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    updateEmailUpdateIdVerifyRaw(requestParameters: UpdateEmailUpdateIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to reset their password after they get a verification code.
     */
    updateEmailUpdateIdVerify(requestParameters: UpdateEmailUpdateIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to login after they get a verification code.
     * @param {string} id 
     * @param {LoginCodeBody} [loginCodeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    updateLoginCodeIdVerifyRaw(requestParameters: UpdateLoginCodeIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>>;

    /**
     * Used by users to login after they get a verification code.
     */
    updateLoginCodeIdVerify(requestParameters: UpdateLoginCodeIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token>;

    /**
     * Used by users to reset their password after they get a verification code.
     * @param {string} id 
     * @param {ResetPasswordBody} [resetPasswordBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApiInterface
     */
    updatePasswordResetIdVerifyRaw(requestParameters: UpdatePasswordResetIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to reset their password after they get a verification code.
     */
    updatePasswordResetIdVerify(requestParameters: UpdatePasswordResetIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class VerificationsApi extends runtime.BaseAPI implements VerificationsApiInterface {

    /**
     * Used by users to request a email update verification code
     */
    async createEmailUpdateRequestRaw(requestParameters: CreateEmailUpdateRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestEmailUpdateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/email-update/request`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestEmailUpdateBodyToJSON(requestParameters['requestEmailUpdateBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestEmailUpdateResponseFromJSON(jsonValue));
    }

    /**
     * Used by users to request a email update verification code
     */
    async createEmailUpdateRequest(requestParameters: CreateEmailUpdateRequestRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestEmailUpdateResponse> {
        const response = await this.createEmailUpdateRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by users to request a login verification code
     */
    async createLoginCodeRequestRaw(requestParameters: CreateLoginCodeRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestLoginCodeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/login-code/request`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestLoginCodeBodyToJSON(requestParameters['requestLoginCodeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestLoginCodeResponseFromJSON(jsonValue));
    }

    /**
     * Used by users to request a login verification code
     */
    async createLoginCodeRequest(requestParameters: CreateLoginCodeRequestRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestLoginCodeResponse> {
        const response = await this.createLoginCodeRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by new user to activate a temporary profile
     */
    async createPassportActivateProfileIdRaw(requestParameters: CreatePassportActivateProfileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createPassportActivateProfileId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/passport/activate_profile/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivateProfileBodyToJSON(requestParameters['activateProfileBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Used by new user to activate a temporary profile
     */
    async createPassportActivateProfileId(requestParameters: CreatePassportActivateProfileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.createPassportActivateProfileIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by users to request a login magic link
     */
    async createPassportMagicSendRaw(requestParameters: CreatePassportMagicSendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/passport/magic/send`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestMagicLinkBodyToJSON(requestParameters['requestMagicLinkBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to request a login magic link
     */
    async createPassportMagicSend(requestParameters: CreatePassportMagicSendRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPassportMagicSendRaw(requestParameters, initOverrides);
    }

    /**
     * Used by users to request a password reset verification code
     */
    async createPasswordResetRequestRaw(requestParameters: CreatePasswordResetRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestPasswordResetResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/password-reset/request`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestPasswordResetBodyToJSON(requestParameters['requestPasswordResetBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestPasswordResetResponseFromJSON(jsonValue));
    }

    /**
     * Used by users to request a password reset verification code
     */
    async createPasswordResetRequest(requestParameters: CreatePasswordResetRequestRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestPasswordResetResponse> {
        const response = await this.createPasswordResetRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create a phone number verification text
     */
    async createPhoneNumberRequestRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("StandardUser", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/phone-number/request`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to create a phone number verification text
     */
    async createPhoneNumberRequest(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPhoneNumberRequestRaw(initOverrides);
    }

    /**
     * Magic link callback — validates token and redirects with auth token or to registration
     */
    async getPassportMagicCallbackRaw(requestParameters: GetPassportMagicCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getPassportMagicCallback().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/passport/magic/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Magic link callback — validates token and redirects with auth token or to registration
     */
    async getPassportMagicCallback(requestParameters: GetPassportMagicCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPassportMagicCallbackRaw(requestParameters, initOverrides);
    }

    /**
     * Used to verify a phone number.
     */
    async getPhoneNumberVerifyCodeRaw(requestParameters: GetPhoneNumberVerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling getPhoneNumberVerifyCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/phone-number/verify/{code}`;
        urlPath = urlPath.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to verify a phone number.
     */
    async getPhoneNumberVerifyCode(requestParameters: GetPhoneNumberVerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPhoneNumberVerifyCodeRaw(requestParameters, initOverrides);
    }

    /**
     * Used by users to reset their password after they get a verification code.
     */
    async updateEmailUpdateIdVerifyRaw(requestParameters: UpdateEmailUpdateIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateEmailUpdateIdVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/email-update/{id}/verify`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmailUpdateBodyToJSON(requestParameters['emailUpdateBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to reset their password after they get a verification code.
     */
    async updateEmailUpdateIdVerify(requestParameters: UpdateEmailUpdateIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEmailUpdateIdVerifyRaw(requestParameters, initOverrides);
    }

    /**
     * Used by users to login after they get a verification code.
     */
    async updateLoginCodeIdVerifyRaw(requestParameters: UpdateLoginCodeIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLoginCodeIdVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/login-code/{id}/verify`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LoginCodeBodyToJSON(requestParameters['loginCodeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Used by users to login after they get a verification code.
     */
    async updateLoginCodeIdVerify(requestParameters: UpdateLoginCodeIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.updateLoginCodeIdVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by users to reset their password after they get a verification code.
     */
    async updatePasswordResetIdVerifyRaw(requestParameters: UpdatePasswordResetIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePasswordResetIdVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/password-reset/{id}/verify`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordBodyToJSON(requestParameters['resetPasswordBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to reset their password after they get a verification code.
     */
    async updatePasswordResetIdVerify(requestParameters: UpdatePasswordResetIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePasswordResetIdVerifyRaw(requestParameters, initOverrides);
    }

}
